export default "__VITE_ASSET__CZ2sS0k4__"